import { useState } from 'react';

import { LBAlert, LBInput } from '@linearb/buzz';
import DeleteFooter from './DeleteFooter';

const CONFIRMATION_TEXT = 'DELETE';

const DeleteConfirmation = ({ onDelete }) => {
  const [confirmationText, setConfirmationText] = useState('');

  return (
    <div>
      <LBAlert variant='destructive' className='flex items-center'>
        Monitoring repositories will be discontinued, and all historical data
        will be erased
      </LBAlert>
      <div className='my-4'>
        <LBInput
          type='text'
          value={confirmationText}
          onChange={e => setConfirmationText(e.target.value)}
        />
        <div className='mt-1 text-base text-muted-foreground'>
          To confirm, type "{CONFIRMATION_TEXT}" (all caps)
        </div>
        <DeleteFooter
          onDelete={onDelete}
          variant='destructive'
          disabled={confirmationText !== CONFIRMATION_TEXT}
        />
      </div>
    </div>
  );
};

export default DeleteConfirmation;
